export default __webpack_public_path__ + "static/media/skyship11.ffe92479.webp";